<template>
  <div class="videoScreen" :class="{ broadScreenview: pubishState }">
    <div id="ag-canvas" class="videoScreen">
      <div class="onBroadCaster" style="background: #000;">
        <div v-if="pubishState" class="profile_state profileStateBrodcast">
          <div class="profile_col">
            <span class="profile-img">
              <span
                class="ag-btn videoExitBtn"
                :class="{ disabled: !readyState }"
                title="Exit"
                @click="handleExit"
              >
                <i class="material-icons">close</i>
                <span class="broadIcon"> {{ $t('stop') }}</span>
              </span>
            </span>
            <div class="profile-title">
              <span class="ag-btn countButton">
                <span class="broadIcon" style="line-height:1">
                  <i class="far fa-eye"></i>
                  {{ liveUserCount }}
                </span>
              </span>
            </div>
          </div>
          <div v-if="readyState" class="ag-btn-group active BroadRigtCol">
            <div class="activityButton">
              <span
                class="questionare_icon"
                id="questionareBtn"
                @click="openQuestinareModal()"
                v-if="this.$store.getters.selected == 'questionary'"
              >
                <span class="questionCounting">
                  <span
                    v-if="this.QnaQuestions.length > 0"
                    class="no_of_question"
                    >{{ this.QnaQuestions.length }}</span
                  >
                  <img src="../assets/images/Q-A_icon.png" style="width:100%" />
                </span>
              </span>
              <!--  <span
                v-if="this.$store.getters.selected === 'shopping'"
                id="shoppingBtn"
                class="shopping_icon"
                @click="boradcastPrdtModel()"
              >
                <img
                  :src="
                    productlistImage === ''
                      ? require('../assets/images/shopping_icon.png')
                      : productlistImage
                  "
                />
              </span> -->
            </div>
          </div>
        </div>

        <div class="event_day">
          <!-- <img
            v-if="event_active"
            src="../assets/images/independence_event-icon.png"
            class="eventImg"
            @click="handleLeaderBoardRedirection"
          />
    
          <img
            src="../assets/images/leaderboard-logo.png"
            class="eventImg"
            @click="handleLeaderBoardRedirection"
          /> -->
          <!-- <slidingTab @weekMonthHandle="handleLeaderBoardRedirection" /> -->
        </div>

        <ChangeCategory
          v-if="
            $store.state.broadCastProductList &&
              $store.state.broadCastProductList.length
          "
          :pubishState="pubishState"
          :room_id="channel"
          :showCategory="showCategory"
          :xAuthId="xAuthId"
          :mobile_no="mobile_no"
          @handleCategoryReopen="handleCategoryReopen"
        />
        <loading :active.sync="isLoading"></loading>
        <div v-if="showBootoutUserModal" class="remove_user_box">
          <p>
            {{ $t('doyou') }}
            <strong style="color: #f085fc;">{{ bootOutUserName }}</strong>
            {{ $t('out') }}
          </p>
          <button
            type="button"
            class="btn btn-success"
            @click="exitUserWhenAbusing(true)"
          >
            {{ $t('yes') }}
          </button>
          <button
            type="button"
            class="btn btn-danger"
            @click="exitUserWhenAbusing(false)"
          >
            {{ $t('no') }}
          </button>
        </div>

        <div v-if="pubishState" class="chatlog-box">
          <ul id="chatRoomList">
            <li
              v-for="item in allMessages"
              :class="{ 'joined-room': item.joined }"
            >
              <div class="chat-list">
                <div class="user-infotext">
                  <span class="user-bage">
                    <img
                      v-if="item.image === null || item.image === 'avatar1'"
                      :src="require('../assets/images/avatar1.png')"
                    />
                    <img v-else :src="item.image" />
                  </span>
                  <span class="viewerName">
                    {{ replcePhoneWithAsterik(item.msg_from, item.joined) }} :
                    <span class="viewerMsg">{{ item.msg }}</span>
                  </span>
                  <span
                    class="kickout"
                    v-if="!item.joined && item.mobile_no !== mobile_no"
                    @click.stop="
                      openKickOutConfirmationModal(
                        item.mobile_no,
                        item.msg_from
                      )
                    "
                  >
                    <i class="material-icons">close</i>
                  </span>
                  <!-- {{showLogs(showBootoutUserModal)}} -->
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="heart-wrapper">
          <div ref="heartRef" class="heartWrap-content"></div>
        </div>

        <div v-if="pubishState" class="chat-bottom">
          <div class="detailChatBox" :class="{ hide: isChatBox }">
            <span
              class="lets_chat"
              @click="toggleChat()"
              id="toggle-chat"
              :class="{ hide: isChatBox }"
            >
              <i class="material-icons">chat</i>
              <span class="chat_text">{{ $t('plzchat') }}</span>
            </span>

            <div v-if="readyState" class="BroadRigtCol">
              <span class="ag-btn videoControlBtn" title="Enable/Disable Audio">
                <i v-if="micOn" class="material-icons" @click="handleMic"
                  >mic</i
                >
                <i v-if="!micOn" class="material-icons" @click="handleMic"
                  >mic_off</i
                >
              </span>
              <!-- v-if="cameras.length > 1" -->
              <!-- @click="switchCamera" -->
              <span class="ag-btn videoControlBtn" title="Switch Camera">
                <i class="material-icons">switch_camera</i>
              </span>

              <span
                class="BroadcasterState callCancle"
                @click="disconnectRemoteCall()"
                v-if="showDisconnectCall"
              >
                <i class="fa fa-phone cancelp" aria-hidden="true"></i>
              </span>

              <span
                v-if="showCallBtn"
                class="broadCallAction"
                :class="{ active: callActive }"
                @click="broadCallDisable()"
              >
                <span class="callEnabled">
                  <i class="material-icons">phone_in_talk</i>
                </span>
                <!-- <span class="callTitle">Call Enable</span> -->
              </span>

              <span
                class="broadCallAction"
                :class="{ active: !callActive }"
                @click="broadCallEnable()"
              >
                <span class="callDisable">
                  <i class="material-icons">phone_locked</i>
                </span>
                <!-- <span class="callTitle">Call Disable</span> -->
              </span>
            </div>
          </div>
          <!-- <div class="itemBox">
            <div class="itemList" :class="{ expand_itemList: allItems }">
              <div class="itemCard_Panel" v-for="(data, key) in this.$store.state.broadCastProductList">
                <div class="itemCards">
                  <img :src="data.itemImage" />
                  <span class="buyers_count"
                    >1160 लोगो ने ये सौदा ख़रीदा है</span
                  >
                  <span class="your_amount">आपकी कीमत</span>
                  <span class="item_amount">
                    ₹ 140.0
                    <span class="actual_amount">240.0</span>
                  </span>
                  <div class="golive_btn">
                    <button type="button" class="btn_red">लाइव जाए</button>
                  </div>
                </div>
              </div>
              <div class="itemCard_Panel">
                <div class="itemCards">
                  <img src="../assets/images/item_default.png" />
                  <span class="buyers_count"
                    >1160 लोगो ने ये सौदा ख़रीदा है</span
                  >
                  <span class="your_amount">आपकी कीमत</span>
                  <span class="item_amount">
                    ₹ 140.0
                    <span class="actual_amount">240.0</span>
                  </span>
                  <div class="golive_btn">
                    <button type="button" class="btn_red">लाइव जाए</button>
                  </div>
                </div>
              </div>
            </div>
          
            <div class="more_item" @click="allItems = !allItems">
              <span v-if="!allItems"
                >More Item
                <i class="material-icons">dehaze</i>
              </span>
              <span v-if="allItems"
                >Close
                <i class="material-icons">close</i>
              </span>
            </div>
          </div> -->
          <BroadCasterProductListLive :channel="channel" :xAuthId="xAuthId" />
        </div>
        <!-- <LeaderBoardTimer
          :intervalTimer="intervalTimer"
          :timerLeft="timerLeft"
          v-if="openBoard && showTimer"
        /> -->

        <LeaderBoard15aug
          v-if="openBoard"
          :XAuthID="xAuthId"
          :leaderBoardViewportList="leaderBoardViewportList"
          :weekMonthLeaderboard="weekMonthLeaderboard"
        />
      </div>
    </div>

    <!--  product list -->
    <div
      id="broadcastproduct-modelbox"
      class="broadcastproductModel wallet modal"
      :class="{ activePrdt: activePrdt }"
    >
      <span class="close-prdt" @click="closeModal()">
        <img src="../assets/images/cross1.png" />
      </span>
      <div class="productInner">
        <div class="title-block">
          <h2>{{ $t('liveItem') }}</h2>
        </div>
        <!-- <BroadCasterProductList
          @true="noLiveProduct"
          :channel="channel"
          :xAuthId="xAuthId"
        /> -->
      </div>
      <div class="change-catgpanel">
        <span class="backIcon" @click="handleOpenCategoryPannel">
          <i class="material-icons">arrow_back</i>
        </span>
        <span class="title">{{ $t('changecategory') }}</span>
      </div>
    </div>

    <!-- The quetionareModal -->
    <div id="Chat-modal" class="wallet modal">
      <div class="modal-content chatPart chat-contentbox chat-bottom">
        <div class="typeComment" v-if="!isChat">
          <input
            id="msg-chatbox"
            v-model="textMessage"
            type="text"
            class="input-chat"
            :placeholder="$t('startchat')"
            @blur="vchfsdcv"
            @keyup.enter="addMessage"
          />
          <span class="send-chat" @click="addMessage()">
            <i class="material-icons fasend">send</i>
          </span>
        </div>
      </div>
    </div>

    <div id="quetionareModal" class="wallet modal">
      <div class="outeranswer-content">
        <div class="modal-content answer-contentbox">
          <div class="modal-body questionList">
            <button
              id="questionareBtn"
              type="button"
              class="close1"
              @click.prevent="closeModal()"
            >
              <img src="../assets/images/cross.png" />
            </button>
            <div class="questionPreview">
              <p v-if="this.QnaQuestions.length > 0" class="heading">
                {{ $t('questiontobeanswer') }}
              </p>
              <ul v-if="this.QnaQuestions.length == 0" class="noQuestion">
                <!--- <p>{{ $t('noquestion') }}</p> -->
                <p>{{ $t('noquestion') }}</p>
              </ul>
              <ul v-else>
                <li v-for="(data, key) in QnaQuestions">
                  <div class="questionIcon">
                    <img
                      v-if="data.wallet_amount"
                      :src="mappedWalletImages(data.wallet_amount)"
                      alt
                    />
                    <img
                      v-if="data.mcash_amount"
                      :src="mappedMCashImages(data.mcash_amount)"
                      alt
                    />
                  </div>
                  <div class="question">
                    <span>{{ data.questions }}</span>
                    <p class="questionTiming">
                      <span :title="data.msg_from">{{ data.msg_from }}</span>
                      <span>
                        {{
                          new Date(data.time_stamp * 1000).toLocaleTimeString()
                        }}
                      </span>
                    </p>
                    <div class="questionCheck">
                      <!-- disabled_icon -->
                      <i
                        :class="
                          key === QNAAnswered
                            ? 'fa fa-times disabled_icon'
                            : 'fa fa-times'
                        "
                        @click.prevent="handleQNACancel(data, key)"
                      ></i>
                      <!-- disabled_icon -->
                      <i
                        :class="
                          key === QNAAnswered
                            ? 'fa fa-check disabled_icon'
                            : 'fa fa-check'
                        "
                        @click.prevent="handleQNAAnswered(data, key)"
                      ></i>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="questionPreview">
              <p v-if="this.answeredQuestion.length > 0" class="answer">
                {{ $t('answeredquestion') }}
              </p>
              <ul v-if="this.answeredQuestion.length > 0">
                <li v-for="(data, key) in answeredQuestion">
                  <div class="questionIcon">
                    <img
                      v-if="data.wallet_amount"
                      :src="mappedWalletImages(data.wallet_amount)"
                      alt
                    />
                    <img
                      v-if="data.mcash_amount"
                      :src="mappedMCashImages(data.mcash_amount)"
                      alt
                    />
                  </div>
                  <div class="question">
                    <span>{{ data.questions }}</span>
                    <p class="questionTiming">
                      <span>{{ data.msg_from }}</span>
                      <span>
                        {{
                          new Date(data.time_stamp * 1000).toLocaleDateString()
                        }}
                      </span>
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="change-catgpanel">
          <span class="backIcon" @click="handleOpenCategoryPannel">
            <i class="material-icons">arrow_back</i>
          </span>
          <span class="title">{{ $t('changecategory') }}</span>
        </div>
      </div>
    </div>

    <div
      class="viewCalloverlay"
      v-if="pubishState"
      v-bind:style="{ display: viewCalloverlay }"
    >
      <div class="viewCallSceenModel">
        <div class="callFromtext">
          <div class="callTitle">
            {{ callingPerson }} {{ $t('CallingYou') }}
          </div>
          <div class="forText">{{ $t('For') }}</div>
          <div class="tiptext">{{ callingCash }} {{ $t('MPointGiveYou') }}</div>
        </div>

        <div class="callState">
          <span class="callCancle" @click="declineRemoteCall()">
            <i class="fa fa-phone" aria-hidden="true"></i>
          </span>
          <span class="callReceivd" @click="acceptCallFromViewer()">
            <i class="fa fa-phone" aria-hidden="true"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { merge } from 'lodash'
import Spinner from 'vue-spinkit'
import * as Cookies from 'js-cookie'
import { AGORA_APP_ID } from '@/agora.config'
import Vue from 'vue'
import LoveComponent from './loveComponent'
import Loading from 'vue-loading-overlay'
import gaali from '../utils/gaali'
import CryptoJS from 'crypto-js'
import {
  replcePhoneWithAsterik,
  initAgora,
  Timer,
  mappedWalletImages,
  mappedMCashImages,
  parsoDi,
  aajDi
} from '../utils/helper'
import { QNAXAuthIds, BASE_API_URL, LOCAL_URL } from '../utils/constant'
import BroadCasterProductList from './BroadCasterProductList'
import { constants } from 'crypto'
import ChangeCategory from './ChangeCategory'
import LeaderBoardTimer from './LeaderBoardTimer'
import LeaderBoard15aug from './leaderBoard15aug'
import BroadCasterProductListLive from './BroadCasterProductListLive'
import slidingTab from './slidingTab'

const tile_canvas = {
  '1': ['span 12/span 24'],
  '2': ['span 12/span 12/13/25', 'span 12/span 12/13/13'],
  '3': ['span 6/span 12', 'span 6/span 12', 'span 6/span 12/7/19'],
  '4': [
    'span 6/span 12',
    'span 6/span 12',
    'span 6/span 12',
    'span 6/span 12/7/13'
  ],
  '5': [
    'span 3/span 4/13/9',
    'span 3/span 4/13/13',
    'span 3/span 4/13/17',
    'span 3/span 4/13/21',
    'span 9/span 16/10/21'
  ],
  '6': [
    'span 3/span 4/13/7',
    'span 3/span 4/13/11',
    'span 3/span 4/13/15',
    'span 3/span 4/13/19',
    'span 3/span 4/13/23',
    'span 9/span 16/10/21'
  ],
  '7': [
    'span 3/span 4/13/5',
    'span 3/span 4/13/9',
    'span 3/span 4/13/13',
    'span 3/span 4/13/17',
    'span 3/span 4/13/21',
    'span 3/span 4/13/25',
    'span 9/span 16/10/21'
  ]
}

export default {
  name: 'AgoraVideoCall',
  components: {
    Spinner,
    CryptoJS,
    Loading,
    BroadCasterProductList,
    ChangeCategory,
    LeaderBoardTimer,
    LeaderBoard15aug,
    BroadCasterProductListLive,
    slidingTab
  },
  props: [
    'transcode',
    'attendeeMode',
    'videoProfile',
    'channel',
    'baseMode',
    'appId',
    'uid'
  ],
  data() {
    return {
      allItems: false,
      noLive: false,
      isChatBox: false,
      isChat: false,
      remoteStream: {},
      QNAAnswered: '',
      mobile_no: '',
      activePrdt1: false,
      micOn: true,
      showCategory: true,
      shoppingActive: false,
      productlistImage: '',
      bubbleImages: [
        'bubble-img',
        'bubble-img1',
        'bubble-img2',
        'bubble-img3',
        'bubble-img4',
        'bubble-img5',
        'bubble-img6'
      ],
      isChecked: false,
      checkedNames: [],
      QnaQuestions: [],
      sliceQuestion: [],
      isQNA: false,
      activeGolive: false,
      someVar: '',
      isLoading: false,
      selectedCategoryIndex: '1',
      items: [
        require('../assets/images/purple_heart.png'),
        require('../assets/images/yellow_heart.png'),
        require('../assets/images/red_heart.png'),
        require('../assets/images/sky_blue_heart.png'),
        require('../assets/images/blue_heart.png')
      ],
      client: {},
      count: 0,
      bootOutUserMobileNo: null,
      showBootoutUserModal: false,
      bootOutUserName: '',
      localStream: {},
      shareClient: {},
      shareStream: {},
      displayMode: 'pip',
      streamList: [],
      readyState: false,
      pubishState: false,
      currentRoomId: '',
      textMessage: '',
      allMessages: [],
      xAuthId: Cookies.get('X-Auth-Id') || null,
      first_name: '',
      last_name: '',
      user_image: '',
      liveUserCount: 0,
      cameras: {},
      selectedCategory: this.$store.getters.selected,
      previousCategoryViewer: '',
      currentCamera: '',
      abusive: gaali,
      answeredQuestion: [],
      activePrdt: false,
      callActive: true,
      viewCalloverlay: 'none',
      showDisconnectCall: false,
      callRequestedTime: '',
      viewerMobileNo: '',
      showCallBtn: true,
      callingPerson: 'Someone',
      callingCash: 1,
      showTimer: false,
      openBoard: false,
      event_active: true,
      timerLeft: {},
      intervalTimer: null,
      weekMonthly: null,
      leaderBoardViewportList: []
    }
  },

  beforeDestroy() {
    document.querySelector('body').classList.remove('popbody')
  },

  mounted() {
    // $('.onRulePage').css(display', 'none');
    this.isQNA = QNAXAuthIds.includes(this.xAuthId)
    // if (this.$store.getters.selected == 'questionary'){
    //   this.pubishState = false
    // }
    console.log('==---=this.$socket==---=', this.$socket)
    this.$socket.on('connect', () => {
      console.log('==connect=---', this.$socket)
      console.log(this.$socket.disconnected)
    })

    var timeRemaining = this.handleDateCounter()
    console.log('===timeRemaining=', timeRemaining)
    if (timeRemaining && timeRemaining.off) {
      window._intervalTimerToogle = false
    }
    this.$socket.emit('pre_live', { xAuthId: this.xAuthId })
    var _this = this
    AgoraRTC.getDevices(function(devices) {
      _this.cameras = devices.filter(device => device.kind === 'videoinput')
      if (_this.cameras.length > 0) {
        _this.currentCamera = _this.cameras[0].deviceId
      }
    })

    __native_money91._onPause = function() {
      _this.$router.go(-1)
    }
  },

  methods: {
    vchfsdcv() {
      // alert('tyugyhj')
      setTimeout(() => {
        this.isChatBox = false
        $('#Chat-modal').modal('hide')
      }, 200)
    },
    toggleChat() {
      this.isChatBox = true
      $('#Chat-modal').modal('show')
      $('#msg-chatbox').focus()
    },
    broadCallEnable() {
      console.log('enable call')
      this.$socket.emit(
        'donot_disturb',
        {
          dnd: false,
          room_id: this.channel,
          mobile_no: this.mobile_no
        },
        () => {
          console.log('enable call emit')
        }
      )
    },
    handleCategoryReopen() {
      this.showCategory = false
    },
    handleOpenCategoryPannel() {
      this.showCategory = true
      this.closeModal()
    },
    boradcastmoney91() {
      console.log('-under')
      this.showCategory = !this.showCategory
    },
    handleDateCounter() {
      this.timerLeft = Timer('14 August,2019 24:00')
      return this.timerLeft
    },
    handleLeaderBoardRedirection(data) {
      this.openBoard = true
      this.weekMonthLeaderboard = data
      console.log('=-=--==-=', this.weekMonthLeaderboard)
      document.querySelector('body').classList.add('leadBodypop')
      this.$http
        .get(
          `${LOCAL_URL}/weekly_and_monthly_leader_board?page_no=1&category=${data}`
        )
        .then(
          function(data) {
            if (data.body) {
              // this.userData = data.body.data.data
              this.leaderBoardViewportList = data.body.data.data
            }
          },
          response => {}
        )
      // if (window._intervalTimerToogle === false) {
      //   document.querySelector('body').classList.add('leadBodypop')
      //   window.clearInterval(window._intervalTimer)
      //   this.showTimer = false
      // } else {
      //   this.showTimer = true
      //   document.querySelector('body').classList.add('popbody')
      //   window._intervalTimer = setInterval(this.handleDateCounter, 1000)
      //   window._intervalTimerToogle = true
      // }
    },

    broadCallDisable() {
      console.log('disable call')
      this.$socket.emit(
        'donot_disturb',
        {
          dnd: true,
          room_id: this.channel,
          mobile_no: this.mobile_no
        },
        () => {
          console.log('disable call')
        }
      )
    },

    noLiveProduct() {
      this.closeModal()
    },

    liveProduct() {
      this.activePrdt = true
    },
    changeLocale(locale) {
      if (['ml', 'te', 'tl', 'ta'].includes(Cookies.get('lang'))) {
        $('body').addClass('activeMultiLang')
        $('.liveTypeList ul').addClass('changeTextMenu')
      }
      if (['kn', 'gu', 'bn'].includes(Cookies.get('lang'))) {
        $('body').addClass('activeBn')
      }
      this.$i18n.locale = Cookies.get('lang')
    },
    replcePhoneWithAsterik,
    mappedWalletImages,
    mappedMCashImages,
    closeModal() {
      $('#quetionareModal').modal('hide')
      $('#broadcastproduct-modelbox').modal('hide')
      $('#Chat-modal').modal('hide')
      this.isChatBox = false
    },
    openQuestinareModal() {
      $('#quetionareModal').modal('show')
    },

    boradcastPrdtModel() {
      $('#broadcastproduct-modelbox').modal('show')
    },

    ruleScroll() {
      $('html, body').animate(
        {
          scrollTop: $('div.onRulePage').offset().top
        },
        800
      )
      // $(".onRulePage").toggle(1000);
    },
    handleCategorySelect(category, index) {
      this.previousCategoryViewer = this.selectedCategory
      this.$store.commit('updateSelected', {
        selected: category
      })
      this.selectedCategory = category
      this.activeGolive = false
    },
    handleQNAAnswered(data, index) {
      const { key, time_stamp, x_auth_id } = data
      this.QNAAnswered = index
      let naeHo = {
        first_name: this.first_name,
        room_id: this.channel,
        x_auth_id: x_auth_id,
        time_stamp: time_stamp,
        answer_by_broadcaster: true
      }
      let belhar = parsoDi(naeHo)
      console.log('===belhar answer=0', belhar)
      this.$socket.emit('respond_by_broadcaster', {
        belhar
      })
      // this.QnaQuestions.splice(key, 1)
    },
    handleQNACancel(data, index) {
      const { key, time_stamp, x_auth_id } = data
      this.QNAAnswered = index
      let naeHo = {
        first_name: this.first_name,
        room_id: this.channel,
        x_auth_id: x_auth_id,
        time_stamp: time_stamp,
        cancel_by_broadcaster: true
      }
      let belhar = parsoDi(naeHo)
      console.log('===belhar answer=0', belhar)
      this.$socket.emit('respond_by_broadcaster', {
        belhar
      })
      // this.QnaQuestions.splice(key, 1)
    },
    add(color) {
      let newcount = ++this.count
      var r = Math.round(Math.random() * 6)
      var img = require(`../assets/images/${color}_heart.png`)
      var ComponentClass = Vue.extend(LoveComponent)
      var instance = new ComponentClass({
        propsData: {
          type: `fa fa-heart ${this.bubbleImages[r]}`,
          src: img,
          id: `faID${newcount}`
        }
      })
      instance.$mount()
      this.$refs.heartRef.appendChild(instance.$el)
      setTimeout(function() {
        document.getElementById(`faID${newcount}`).remove()
      }, 2000)
    },
    back() {
      $('.onRulePage').removeClass('active_screen')
      // this.$router.push('/');
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.push('/')
      }
    },
    switchCamera() {
      var _this = this
      var nextCamera = _this.cameras.filter(
        camera => camera.deviceId !== _this.currentCamera
      )
      if (nextCamera.length > 0) {
        _this.localStream.switchDevice('video', nextCamera[0].deviceId)
        _this.currentCamera = nextCamera[0].deviceId
      }
    },
    scrollToBottom() {
      setTimeout(function() {
        var a = $('.chatlog-box ul')
        a.animate({
          scrollTop: a[0].scrollHeight
        })
      }, 100)
    },

    exitUserWhenAbusing(isConfirm) {
      if (isConfirm) {
        this.$socket.emit(
          'kick_out_user_from_room',
          { mobile_no: this.bootOutUserMobileNo, room_id: this.channel },
          () => {
            console.log('stop_broadcast')
          }
        )
        this.showBootoutUserModal = false
        this.bootOutUserName = ''
      } else {
        this.bootOutUserMobileNo = null
        this.showBootoutUserModal = false
        this.bootOutUserName = ''
      }
    },
    showLogs(data) {
      console.log('logs>>> ', data)
    },
    openKickOutConfirmationModal(mobile, name) {
      this.bootOutUserMobileNo = mobile
      this.showBootoutUserModal = true
      this.bootOutUserName = name
    },
    scrollToBottom() {
      setTimeout(function() {
        var a = $('#chatRoomList')
        a.animate({
          scrollTop: a[0].scrollHeight
        })
      }, 100)
    },
    addMessage: function() {
      if (this.textMessage != '' && this.textMessage.trim().length > 0) {
        var textMessage = this.textMessage.toLowerCase()
        for (var _ in this.$data.abusive) {
          if (textMessage.indexOf(this.$data.abusive[_].toLowerCase()) > -1) {
            // console.log(this.$data.abusive[_])
            alert(this.$t('accountMayBlock'))
            return
          }
        }
        this.$socket.emit(
          'text',
          {
            xAuthId: this.xAuthId,
            room_id: this.channel,
            msg: this.textMessage
          },
          () => {
            console.log('message sent')
            this.scrollToBottom()
          }
        )
        this.textMessage = ''
      } else {
        this.$toast.bottom(this.$t('writeComment'))
      }
    },

    streamInit(uid, attendeeMode, videoProfile, config) {
      let defaultConfig = {
        streamID: uid,
        audio: true,
        video: true,
        screen: false,
        cameraId: this.currentCamera
      }

      let stream = AgoraRTC.createStream(merge(defaultConfig, config))
      stream.setVideoProfile(videoProfile)
      return stream
    },

    subscribeStreamEvents() {
      let rt = this

      rt.client.on('stream-added', function(evt) {
        console.log('here')
        let stream = evt.stream
        rt.remoteStream = stream

        console.log('this.remoteStream ', rt.remoteStream)
        rt.client.subscribe(stream, function(err) {
          console.log('Subscribe stream failed', err)
        })
      })

      rt.client.on('stream-subscribed', function(evt) {
        let stream = evt.stream
        console.log(new Date().toLocaleTimeString())
        console.log('Subscribe remote stream successfully: ' + stream.getId())
        console.log(evt)
        rt.remoteStream = stream
        rt.addStream(stream)
      })

      rt.client.on('peer-leave', function(evt) {
        console.log('Peer has left: ' + evt.uid)
        console.log(new Date().toLocaleTimeString())
        console.log(evt)
        rt.removeStream(evt.uid)
      })

      rt.client.on('stream-removed', function(evt) {
        let stream = evt.stream
        console.log('Stream removed: ' + stream.getId())
        console.log(new Date().toLocaleTimeString())
        console.log(evt)
        rt.removeStream(stream.getId())
      })

      rt.client.on('client-role-changed', function(evt) {
        console.log('client-role-changed', evt.role)
        console.log('client-role-changed', evt)
      })
    },

    removeStream(uid) {
      this.streamList.map((item, index) => {
        if (item.getId() === uid) {
          item.close()
          let element = document.querySelector('#ag-item-' + uid)
          if (element) {
            element.parentNode.removeChild(element)
          }
          let tempList = [...this.streamList]
          tempList.splice(index, 1)
          this.streamList = tempList
        }
      })
    },

    addStream(stream, push = false) {
      let repeatition = this.streamList.some(item => {
        return item.getId() === stream.getId()
      })
      if (repeatition) {
        return
      }
      if (push) {
        this.streamList = this.streamList.concat([stream])
      } else {
        this.streamList = [stream].concat(this.streamList)
      }
    },

    handleCamera(e) {
      e.currentTarget.classList.toggle('off')
      this.localStream.isVideoOn()
        ? this.localStream.disableVideo()
        : this.localStream.enableVideo()
    },

    handleMic(e) {
      // e.currentTarget.classList.toggle('off')
      this.micOn = !this.micOn
      this.localStream.isAudioOn()
        ? this.localStream.disableAudio()
        : this.localStream.enableAudio()
    },

    handleExit(e) {
      this.disconnectRemoteCall()
      this.$store.commit('updateSelected', {
        selected: ''
      })
      this.$store.commit('broadCastProductList', [])
      this.$store.commit('broadCastProductListLive', '')
      try {
        JSBridgePlugin.keepScreenOn(false)
      } catch (e) {
        console.log('----web---', e)
      }
      console.log('close', this.attendeeMode)
      if (e.currentTarget.classList.contains('disabled')) {
        return
      }
      this.$socket.emit('stop_broadcast', { room_id: this.channel }, () => {
        console.log('stop_broadcast')
      })

      try {
        this.client && this.client.unpublish(this.localStream)
        this.localStream && this.localStream.close()
        this.client &&
          this.client.leave(
            () => {
              document.querySelector('body').classList.remove('modal-open')
              $('.modal-backdrop').css('display', 'none')
              console.log('Client succeed to leave.')
            },
            () => {
              console.log('Client failed to leave.')
            }
          )
      } finally {
        this.readyState = false
        this.client = null
        this.localStream = null
        if (window.history.length > 1) {
          this.$router.go(-1)
        } else {
          this.$router.push('/')
          this.preLoader = false
        }
      }
    },

    acceptCallFromViewer() {
      console.log('accept_call', this.xAuthId, this.viewerMobileNo)
      let naeHo = {
        room_id: this.channel,
        call_requested_time: this.callRequestedTime,
        x_auth_id: this.xAuthId,
        viewer_mobile_no: this.viewerMobileNo
      }
      let cipher_text = parsoDi(naeHo)
      this.$socket.emit(
        'accept_call',
        {
          cipher_text
        },
        () => {
          // let $ = this
          // console.log('this.remoteStream', $.remoteStream)
          // $.client.subscribe($.remoteStream, function(err) {
          //   console.log('Subscribe stream failed', err)
          // })
          this.viewCalloverlay = 'none'
        }
      )
    },

    disconnectRemoteCall() {
      console.log('--===disconnectRemoteCall=--')
      let naeHo = {
        room_id: this.channel
      }
      let cipher_text = parsoDi(naeHo)
      this.$socket.emit(
        'disconnect_call',
        {
          cipher_text
        },
        () => {
          console.log('disconnect_call')
          let $ = this
          $.client.unsubscribe($.remoteStream, function(err) {
            console.log(err)
          })
          this.viewCalloverlay = 'none'
        }
      )
    },

    declineRemoteCall() {
      console.log('==---=decline---')
      let naeHo = {
        room_id: this.channel,
        mcash: this.callingCash
      }
      let cipher_text = parsoDi(naeHo)
      console.log('--===declineRemoteCall=--')
      this.$socket.emit(
        'decline_call',
        {
          cipher_text
        },
        () => {
          console.log('decline_call')
          let $ = this
          $.client.unsubscribe($.remoteStream, function(err) {
            console.log(err)
          })
          this.viewCalloverlay = 'none'
        }
      )
    },

    startBroad() {
      console.log('here')
      let $ = this
      // init AgoraRTC local client
      $.client = AgoraRTC.createClient({ mode: $.transcode })
      $.client.init($.appId, () => {
        console.log('AgoraRTC client initialized')
        $.subscribeStreamEvents()

        // alert(uid);
        $.client.join($.appId, $.channel, $.uid, uid => {
          console.log('User ' + uid + 'join channel successfully')
          console.log('At ' + new Date().toLocaleTimeString())
          // create local stream
          // It is not recommended to setState in function addStream
          $.localStream = this.streamInit(uid, $.attendeeMode, $.videoProfile)
          $.localStream.init(
            () => {
              if ($.attendeeMode !== 'audience') {
                $.addStream($.localStream, true)
                $.client.publish($.localStream, err => {
                  // switchDevice(type: "audio" | "video", deviceId: string, onSuccess?: function, onFailure?: function)

                  console.log('Publish local stream error: ' + err)
                })
              }
              $.readyState = true
              this.isLoading = false
            },
            err => {
              console.log('getUserMedia failed', err)
              $.readyState = true
            }
          )
        })
      })
    },

    startPublish() {
      this.isLoading = true
      this.startBroad()
      this.pubishState = true
      this.$socket.emit(
        'live',
        {
          room_id: this.channel,
          xAuthId: Cookies.get('X-Auth-Id'),
          app_id: AGORA_APP_ID,
          category: 'money91'
        },
        () => {
          clevertap.event.push('BROADCASTING', {
            id: Cookies.get('X-Auth-Id')
          })
        }
      )
    }
  },

  sockets: {
    call_disconnected: function(data) {
      console.log('=call_disconnected=---=data=', data)
      this.showDisconnectCall = false
      this.showCallBtn = true
    },
    remove_call_option: function(data) {
      this.viewCalloverlay = 'none'
      this.showCallBtn = true
    },
    call_received: function(data) {
      let dataDecrypted = aajDi(data)
      this.showDisconnectCall = true
      this.showCallBtn = false
      this.viewCalloverlay = 'none'
    },

    call_decline: function(data) {
      this.showDisconnectCall = false
      this.showCallBtn = true
      this.$toast.bottom(data.message)
      this.viewCalloverlay = 'none'
    },

    call_initiated: function(data) {
      console.log('===call_initiated==', data)
      let dataDecrypted = aajDi(data)
      console.log('==-data1--==', dataDecrypted)
      this.viewCalloverlay = 'block'
      console.log('--======--------==data==', dataDecrypted)
      this.callingPerson = dataDecrypted.viewer_name
      this.callingCash = dataDecrypted.mcash || 1

      this.callRequestedTime = dataDecrypted.call_requested_time
      this.viewerMobileNo = dataDecrypted.viewer_mobile_no
    },

    dnd: function(data) {
      console.log('grbvhrbhgbhh')
      if (data.dnd) {
        this.callActive = false
      } else {
        this.callActive = true
      }
    },
    // error: function(data) {
    //   this.$toast.bottom(data.message)
    // },

    special_effect_response: function(data) {
      this.add(data.color)
    },

    answer_response: function(data) {
      if (data.qna_status === 'answered') {
        this.QnaQuestions.splice(this.QNAAnswered, 1)
        this.QNAAnswered = ''
        return this.answeredQuestion.push(data.data)
      } else {
        this.QnaQuestions.splice(this.QNACancel, 1)
        this.QNAAnswered = ''
        return this.answeredQuestion
      }
    },
    broadcaster_ordered_history: function(data) {
      if (data.data.length > 0) {
        this.noLive = false
        this.isLoading = false
        this.$store.commit('broadCastProductList', data.data)
        this.$store.commit(
          'broadCastProductListLive',
          data.data && data.data[0]
        )
        // this.productlistImage = data.data && data.data[0].
        this.$store.commit('noLive', this.noLive)
      } else {
        this.noLive = true
        this.$store.commit('noLive', this.noLive)
      }
    },
    new_live_product: function(data) {
      // this.productlistImage = data.data.itemImage
      this.$store.commit('broadCastProductListLive', data.data)
    },
    changed_category: function(data) {
      console.log('-----data---', data)
    },
    new_questions: function(data) {
      var decryptedData = aajDi(data.data)
      this.$toast.bottom(this.$t('addedQues'))
      this.QnaQuestions = decryptedData
    },
    status: function(data) {
      try {
        JSBridgePlugin.keepScreenOn(true)
      } catch (e) {
        console.log('----web---', e)
      }
      this.channel = data.room_id
      this.first_name = data.first_name
      this.last_name = data.last_name
      this.user_image = data.image
      this.mobile_no = data.mobile_no
      console.log('status', this.channel)
      this.startPublish()
      this.$socket.emit('change_category', {
        mobile_no: data.mobile_no,
        category: 'shopping',
        room_id: data.room_id
      })
    },

    new_comment: function(data) {
      this.allMessages.push(data)
      this.scrollToBottom()
    },

    previous_comments: function({ data }) {
      if (data.room_id === this.channel) {
        this.allMessages.push(data.all_comments)
        console.log('this.allMessages', this.allMessages)
        this.scrollToBottom()
      }
    },

    leave_room: function(data) {
      this.$toast.bottom(data.msg)
    },

    live_connected_user_count: function(data) {
      if (data.room_id === this.channel) {
        this.liveUserCount = data.live_user_count
      }
    },

    stop_live_streaming: function(data) {
      try {
        this.client && this.client.unpublish(this.localStream)
        this.localStream && this.localStream.close()
        this.client &&
          this.client.leave(
            () => {
              document.querySelector('body').classList.remove('modal-open')
              $('.modal-backdrop').css('display', 'none')
              console.log('Client succeed to leave.')
            },
            () => {
              console.log('Client failed to leave.')
            }
          )
      } finally {
        this.readyState = false
        this.client = null
        this.localStream = null
        if (window.history.length > 1) {
          this.$router.go(-1)
        } else {
          this.$router.push('/')
          this.preLoader = false
        }
      }
    },

    disconnection: function(data) {
      this.$toast.bottom(data.msg)
    }
  },

  beforeUpdate() {
    initAgora(this.streamList, this.displayMode)
  },

  beforeDestroy() {
    this.$socket.emit('stop_broadcast', { room_id: this.channel }, () => {
      console.log('stop_broadcast')
    })

    this.client && this.client.unpublish(this.localStream)
    this.localStream && this.localStream.close()
    this.client &&
      this.client.leave(
        () => {
          document.querySelector('body').classList.remove('modal-open')
          $('.modal-backdrop').css('display', 'none')
          console.log('Client succeed to leave.')
        },
        () => {
          console.log('Client failed to leave.')
        }
      )
  }
}
</script>

<style scoped>
.cancelp {
  height: 32px;
  background: #ff0f00;
  border-radius: 50%;
  padding: 8px;
  transform: translate(-50%, -50%) rotate(225deg);
  top: 16px;
  position: absolute;
  right: 25px;
}
.liveScreen .selectMusic {
  text-align: left !important;
}
.remove_user_box {
  z-index: 999;
}
</style>
